// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, CardMedia, Grid, Typography } from '@mui/material';
import imageGradient from '../assets/gradient.png';
import imageRegistry from '../assets/registry.webp';
import useStyles from './styles';

const Root: React.FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 6 }}>
      <Grid container direction="column">
        <Grid item xs={12}>
          <Typography variant="h1" color="primary">
            Welcome to the Canton Utility
          </Typography>
          <Typography variant="h5">The following modules are available to you:</Typography>
          <Grid container direction="row" spacing={4} sx={{ marginTop: 0 }}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Card className={classes.card}>
                <Box style={{ height: '100%' }}>
                  <CardActionArea onClick={() => navigate('/registry/onboarding')}>
                    <CardMedia
                      className={classes.cardMediaLarge}
                      image={imageRegistry}
                      title="Registry"
                    />
                    <CardMedia
                      className={classes.cardMediaLargeOverlay}
                      image={imageGradient}
                      title="Registry"
                    />
                    <Box className={classes.cardMediaText}>
                      <Typography className={classes.cardTitle}>Registry</Typography>
                      <Typography className={classes.cardText}>Manage inventory</Typography>
                    </Box>
                  </CardActionArea>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Root;
